<template lang="pug">
    v-container(style='max-width: 1185px;')
        //- Content
        v-snackbar(v-model="snackbar" color="red" top)
            | El archivo subido no es del formato adecuado .csv
            template(v-slot:action="{ attrs }")
                v-btn(color="white" text="" v-bind="attrs" @click="snackbar = false")
                    | Cerrar
        v-card(color="#eee" flat)
            v-card-title
                v-divider
                h4 Importar tiendas virtuales
            v-card-text.pa-0
              v-stepper(v-model="e6" )
                v-stepper-header
                  v-stepper-step(:complete="e6 > 1" step="1")
                    | Selecciona el archivo
                    small csv
                  v-stepper-step(:complete="e6 > 2" step="2")
                    //| Asigna columnas de tender
                    |Verifica los datos
                  v-stepper-step(step="3")
                    | Elige la categoria
                  v-stepper-step(step="4")
                    | Publica
                v-stepper-items
                  v-stepper-content(step="1")
                    v-row
                      v-col(cols="12" )
                          v-card(flat link height="200px" style='display:flex;justify-content:center; align-items:center;').category-card
                            input#csv_file.form-control(style='display:none;' type='file', name='csv_file', @change='loadCSV($event)' accept=".csv")
                            v-file-input(@change='loadCSV($event)' v-model="files" color="deep-purple accent-4" counter="" label="Archivo a importar"  placeholder="Seleccìona un archivo CSV" prepend-icon="mdi-paperclip" outlined="" :show-size="1000")
                              template(v-slot:selection="{ index, text }")
                                v-chip(v-if="index < 2" color="deep-purple accent-4" dark="" label="" small="")
                                  | {{ text }}
                                span.overline.grey--text.text--darken-3.mx-2(v-else-if="index === 2")
                                  | +{{ files.length - 2 }} File(s)
                    v-btn(text="" @click="importInventory = false")
                      | Cancelar
                    v-btn(color="primary" @click="e6 = 2" :disabled='!files').mx-2
                      | Continuar
                  v-stepper-content(step="2")
                    v-row.my-0.py-0
                      v-col(cols="12")
                        v-data-table(:headers="headers", :items="parse_csv", :items-per-page="5", dense, :search='search')
                          template( v-slot:item="props" )
                            tr
                              td {{ props.index + 1 }}
                              td {{ props.item.Name }}
                              td {{ props.item.Full_Address || 'No registra' }}
                              td {{ props.item.Category || ''}}
                              td {{ props.item.Phone || 'No registra'}}
                              td {{ props.item.Lat }}
                              td {{ props.item.Lng }}
                              td {{ props.item.Rating || 0}}
                              td {{ props.item.Reviews || 0}}
                              td {{ props.item.Description || ''}}
                              td {{ props.item.Monday || ''}}
                              td {{ props.item.Tuesday || ''}}
                              td {{ props.item.Wednesday || ''}}
                              td {{ props.item.Thursday || ''}}
                              td {{ props.item.Friday || ''}}
                              td {{ props.item.Saturday || ''}}
                              td {{ props.item.Sunday || ''}}
                              td {{ props.item.Top_Image_URL || ''}}
                    v-btn(text=""  @click="e6 = 1")
                      | Atras
                    v-btn(color="primary" @click="e6 = 3").mx-2
                      | Continuar
                  v-stepper-content(step="3")
                    v-card.mb-12(color="transparent" flat height="200px")
                      v-col(cols="12")
                        .text-center(style="display:flex; align-items:center;")
                          v-select(:items='mainCategories', item-text='data' return-object label='Categoría principal' v-model="mainCategorySelected")
                    v-btn(text="" @click="e6 = 2")
                      | Atras
                    v-btn(color="primary" :disabled="!mainCategorySelected" @click="e6 = 4").mx-2
                      | Continuar
                  v-stepper-content(step="4")
                    v-card.mb-12(color="grey lighten-5" height="200px" style='display:flex; flex-direction:column; justify-content:center; align-items:center;')
                      p Eso es todo, dale click a subir tiendas para agregarlas al marketplace de tender
                    v-btn(text="" @click="e6 = 3")
                      | Atras
                    v-btn( style="padding: 20px !important" color="primary" :disabled='parse_csv.length === 0 || isLoading' :loading='isLoading' @click="uploadBulk" ).mx-2
                      | Subir tiendas
</template>

<script>
  import Swal from 'sweetalert2'
  const csv2json = require('@/plugins/cvs2json')
  export default {
    name: 'UploadBotsol',
    components: {
    },
    data () {
      return {
        files: [],
        e6: 1,
        snackbar: false,
        isLoading: false,
        search: '',
        mainCategories: [],
        mainCategorySelected: null,
        /*
        id,Name,Full_Address, Street_Address,City,State,Zip,Plus_Code,Website,Phone,Email,Facebook,Twitter,
        Instagram,Lat,Lng,Verification_Text,Category,Rating,Reviews,Top_Image_URL,Sub_Title,Pricing,Amenities,
        Description,Summary,Monday,Tuesday,Wednesday,Thursday,Friday,Saturday,Sunday,External_Urls,Photo_Tags,URL,
        */
        headers: [
          {
            sortable: false,
            text: 'INDICE',
            value: 'id',
            align: 'left',
          },
          {
            sortable: false,
            text: 'NOMBRE',
            value: 'Name',
            align: 'left',
          },
          {
            sortable: true,
            text: 'DIRECCIÓN',
            value: 'Full_Address',
            align: 'left',

          },
          {
            sortable: true,
            text: 'SUBCATEGORIA',
            value: 'CATEGORY',
            align: 'left',
          },
          {
            sortable: true,
            text: 'TELEFONO',
            value: 'Phone',
            align: 'left',
          },
          {
            sortable: true,
            text: 'LATITUD',
            value: 'Lat',
            align: 'left',

          },

          {
            sortable: false,
            text: 'LONGITUD',
            value: 'Lng',
            align: 'left',

          },
          {
            sortable: false,
            text: 'CALIFICACIÓN',
            value: 'Rating',
            align: 'left',
          },
          {
            sortable: false,
            text: 'COMENTARIOS',
            value: 'Reviews',
            align: 'left',
          },
          {
            sortable: false,
            text: 'DESCRIPCIÓN',
            value: 'Description',
            align: 'left',

          },
          // Monday,Tuesday,Wednesday,Thursday,Friday,Saturday,Sunday
          {
            sortable: false,
            text: 'LUNES',
            value: 'Monday',
            align: 'left',

          },
          {
            sortable: false,
            text: 'MARTES',
            value: 'Tuesday',
            align: 'left',

          },
          {
            sortable: false,
            text: 'MIERCOLES',
            value: 'Wednesday',
            align: 'left',

          },
          {
            sortable: false,
            text: 'JUEVES',
            value: 'Thursday',
            align: 'left',

          },
          {
            sortable: false,
            text: 'VIERNES',
            value: 'Friday',
            align: 'left',

          },

          {
            sortable: false,
            text: 'SABADO',
            value: 'Saturday',
            align: 'left',

          },
          {
            sortable: false,
            text: 'DOMINGO',
            value: 'Sunday',
            align: 'left',

          },
          {
            sortable: false,
            text: 'IMAGEN',
            value: 'Top_Image_URL',
            align: 'left',

          },
        ],
        parse_csv: [],
      }
    },
    computed: {
      isMobile () {
        return window.innerWidth < 1024
      },
    },
    created () {
      const vm = this
      vm.$store.dispatch('shops/getMainCategories', 'en').then(res => {
        if (res) {
          const categories = res.sort((a, b) => {
            if (a.data > b.data) {
              return 1
            }
            if (a.data < b.data) {
              return -1
            }
            return 0
          })
          vm.mainCategories = categories
        }
      })
    },
    methods: {
      uploadBulk () {
        const vm = this
        vm.isLoading = true
        const data = {
          csv: vm.parse_csv,
          mainCategorie: vm.mainCategorySelected,
        }
        vm.$store.dispatch('parsers/uploadBotsolShops', data).then(function () {
          vm.isLoading = false
          vm.files = null
          vm.e6 = 1
          vm.mainCategorySelected = null
          Swal.fire({
            title: 'Tiendas cargadas!',
            text: 'Las tiendas han sido cargadas a la base de datos exitosamente!',
            icon: 'success',
            showCancelButton: false,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Ok',
          })
        })
      },
      loadCSV (e) {
        const vm = this
        if (vm.files.type.includes('excel') || vm.files.name.includes('csv')) {
          if (window.FileReader) {
            const reader = new FileReader()
            reader.readAsText(vm.files, 'ANSI')
            // Handle errors load

            reader.onload = function (event) {
              // console.log(event)
              const csv = event.target.result
              // console.log(csv)
              vm.parse_csv = csv2json(csv, { parseNumbers: true })
              // console.log(vm.parse_csv)
            }
            reader.onerror = function (evt) {
              if (evt.target.error.name === 'NotReadableError') {
                alert('No es posible leer el archivo!')
              }
            }
          } else {
            alert('FileReader are not supported in this browser.')
          }
        } else {
          vm.snackbar = true
          document.getElementById('csv_file').value = ''
        }
      },
    },
  }
</script>

<style scoped lang="scss">
    .panel {
        border: 2px solid #dfdfdf;
        box-shadow: rgba(0, 0, 0, 0.15) 0 1px 0 0;
        margin: 10px;
    }
    .panel.panel-sm {
        max-width: 700px;
        margin: 10px auto;
    }
    .panel-heading {
        border-bottom: 2px solid #dfdfdf;
    }
    .panel-heading h1, .panel-heading h2, .panel-heading h3, .panel-heading h4, .panel-heading h5, .panel-heading h6 {
        margin: 0;
        padding: 0;
    }
    .panel-body .checkbox-inline {
        padding: 15px 20px;
    }
    table {
        font-family: arial, sans-serif;
        border-collapse: collapse;
        width: 100%;
    }

    td, th {
        border: 1px solid #dddddd;
        text-align: left;
        padding: 8px;
    }

    tr:nth-child(even) {
        background-color: #dddddd;
    }
</style>
